import { render, staticRenderFns } from "./zxgl.vue?vue&type=template&id=a0821328&scoped=true&"
import script from "./zxgl.vue?vue&type=script&lang=js&"
export * from "./zxgl.vue?vue&type=script&lang=js&"
import style0 from "./zxgl.vue?vue&type=style&index=0&id=a0821328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0821328",
  null
  
)

export default component.exports